import React from 'react';

const InputInfo = props => (
  <svg width={24} height={25} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#a)" stroke="#fff" strokeWidth={1.5} strokeLinejoin="round">
      <path
        d="M23 12.31c.11 6.08-4.92 11.09-11 11.19-6.07.1-10.89-4.73-11-10.81C.9 6.62 5.93 1.6 12 1.5c6.07-.11 10.89 4.73 11 10.81ZM12 14V7"
        strokeLinecap="round"
      />
      <path d="M12.5 17.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5.22-.5.5-.5.5.22.5.5Z" fill="#fff" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default InputInfo;
